module.exports = __webpack_public_path__ + "static/media/may-youtube.4796cfca.jpg";